import React from 'react';
import CommonSelect from './commonSelect';
import { DistrictOptions } from '../../../../../../core/data/json/apmc';

interface EditSectionProps {
  editingIndex: number | null;
  currentIndex: number;
  item: any; // The form field data item
  annexure:string;
  updatedFields: any;
  setUpdatedFields: React.Dispatch<React.SetStateAction<any>>; // 👈 new
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => void;
  handlePercentageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePercentageBlur: () => void;
  handleUpdateSubmit: (index: number, responses: any[],annexure:string) => void;
}

const EditSection: React.FC<EditSectionProps> = ({
  editingIndex,
  currentIndex,
  item,
  updatedFields,
  setUpdatedFields,
  handleFileChange,
  handlePercentageChange,
  annexure,
  handlePercentageBlur,
  handleUpdateSubmit,
}) => {
  if (editingIndex !== currentIndex) {
    return null;
  }

  return (
    <div className="d-flex flex-column border-top border-secondary bg-white p-3">
      <h4 className='border-bottom border-3 border-success mb-3'>Edit Values and Comment</h4>

      {/* File Inputs */}
      <div className="d-flex gap-3 flex-wrap mb-3">
        {item.response
          .filter((r: any) => r.responseType === "file" || r.responseType === "button")
          .map((r: any, fileIdx: number) => (
            <div key={fileIdx} className="d-flex flex-column w-25">
              <label className="fw-semibold mb-1">{r.responseName}</label>
              <input 
                className='form-control w-75' 
                type='file'  
                onChange={(e) => handleFileChange(e, `${r.fieldName}`)} 
                name={`${r.responseVal}`}  
                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                id='uploadPlan'
              />
            </div>
          ))}
      </div>

      {/* Other Input Types */}
      <div className="d-flex gap-3 flex-wrap mb-3">
        {item.response
          .filter((r: any) => r.responseType !== "file" && r.responseType !== "button")
          .map((r: any, inputIdx: number) => {
            const inputKey = `${currentIndex}_${inputIdx}`;
            const label = r.responseName;

            switch (r.responseType) {
case "input":
  return (
    <div key={inputKey} className="d-flex flex-column w-25">
      <label className="fw-semibold mb-1">{label}</label>
      <input
        type="text"
        className="form-control"
        placeholder="Enter value"
        name={`${r.responseVal}`}
        value={updatedFields[`updateInput_${inputKey}`] || ""}
        onChange={(e) =>
          setUpdatedFields((prev: any) => ({
            ...prev,
            [`updateInput_${inputKey}`]: e.target.value,
          }))
        }
      />
    </div>
  );

case "percentage":
  return (
    <div key={inputKey} className="d-flex flex-column w-25">
      <label className="fw-semibold mb-1">{label}</label>
      <input
        type="text"
        inputMode="decimal"
        className="form-control"
        placeholder="0 - 100"
        value={updatedFields[`${r.responseVal}`] || ""}
        onChange={(e) => {
          let val = e.target.value;

          // Allow only numbers and at most one decimal
          if (/^\d{0,2}(\.\d{0,2})?$/.test(val)) {
            // Limit to 0 - 100
            if (val === "" || (parseFloat(val) >= 0 && parseFloat(val) <= 100)) {
              setUpdatedFields((prev: any) => ({
                ...prev,
                [r.responseVal]: val,
              }));
            }
          }
        }}
        onBlur={handlePercentageBlur}
        name={`${r.responseVal}`}
      />
    </div>
  );


              case "radio":
                return (
                  <div key={inputKey} className="d-flex flex-column w-25">
                    <label className="fw-semibold mb-1">{label}</label>
                    <label>
                      <input
                        type="radio"
                        name={`updateRadio_${inputKey}`}
                        value="yes"
                      />{" "}
                      Yes
                    </label>
                    <label>
                      <input
                        type="radio"
                        name={`updateRadio_${inputKey}`}
                        value="no"
                      />{" "}
                      No
                    </label>
                  </div>
                );

              case "select":
                return (
                  <div key={inputKey} className="d-flex flex-column w-25">
                    <label className="fw-semibold mb-1">{label}</label>
                    <CommonSelect
                      className="form-select"
                      options={DistrictOptions}
                      placeholder="Select option"
                      name={`updateSelect_${inputKey}`}
                      onChange={(option) => {
                       
                      }}
                    />
                  </div>
                );

              default:
                return null;
            }
          })}
      </div>

      {/* Comment + Submit */}
      <div className="d-flex justify-content-end w-100 gap-2">
        <button
          className="btn btn-success w-25 h-50"
          onClick={() => handleUpdateSubmit(currentIndex, item.response,annexure)}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default EditSection;